import React, {Component} from 'react'
import LoginForm from 'components/LoginForm'

import 'styles/login.css'

class Login extends Component {
  render() {
    return (
      <div className="login login-container">
        <div className="logo">
          <img src="images/logo.jpg" alt="logo"/>
        </div>
        <p className="logo-text">智&emsp;天&emsp;下</p>
        <div className="logo-form">
          <LoginForm/>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login.js